<div
    class="pn-app-light:bg-[var(--color-primary)] sr-app-light:bg-[var(--color-primary)] flex h-full w-full flex-col items-center justify-center overflow-hidden bg-[var(--color-secondary)] text-base dark:bg-contrast-black">
    <ng-container [ngSwitch]="onboardingStatus">
        <rwidget-language-selection
            class="h-full w-full"
            *ngSwitchCase="onboardingType.STARTED"
            (proceedNextView)="updateOnBoardingStatus($event)">
        </rwidget-language-selection>

        <!-- Onboarding flow -->
        <div
            class="flex h-full w-full flex-col items-center justify-center"
            *ngSwitchCase="onboardingType.ONBOARD_FLOW">
            <swiper
                class="swiper introduction-slider h-full w-full"
                [config]="noticesSliderConf"
                [class.disabled]="isDisableNavigation"
                [class.terms-page]="
                    !env.IS_NEW_AFC && isSlideEnd && isShowTermsAndConditions && !env.ONBOARDING?.SHOW_BACK_BUTTON
                "
                (transitionEnd)="this.isSlideEnd = $event[0].isEnd"
                (click)="clickToLogin($event)"
                (touchEnd)="touchToLogin($event)"
                (swiper)="onSwiperInit($event)"
                (slideChange)="onSlideChange($event)">
                <ng-template
                    *ngFor="
                        let slide of [].constructor(env.ONBOARDING.FLOW.SLIDES);
                        let i = index;
                        trackBy: trackByIndex
                    "
                    swiperSlide>
                    <ng-container *ngIf="env.ONBOARDING.FLOW.TYPE === 'ICON'">
                        <article
                            class="mt-[25vh] flex flex-col items-center"
                            [ngClass]="{ hidden: i !== currentSlide }"
                            aria-live="polite">
                            <ion-icon
                                class="vl-app-light-dark:text-white h-32 w-32"
                                *ngIf="onlyPortraitMode$ | async"
                                aria-hidden="true"
                                src="{{ assetsPath$ | async }}/img/onboarding/slide-icon-{{ +i }}.svg"></ion-icon>
                            <p
                                class="sr-app-light:text-black mt-4 w-60 text-center font-bold"
                                *ngIf="env.ONBOARDING?.SHOW_TITLE_STEPS"
                                [ngClass]="{ 'text-white': env.THEME_NAME !== 'varmland' }">
                                {{ 'ONBOARDING_SLIDE_TITLE_' + i | translate }}
                            </p>
                            <p
                                class="sr-app-light:text-black mt-10 w-60 text-center text-base"
                                [ngClass]="{
                                    'text-white': env.THEME_NAME !== 'varmland',
                                    'mt-2': env.ONBOARDING?.SHOW_TITLE_STEPS
                                }">
                                {{ 'ONBOARDING_SLIDE_TEXT_' + i | translate }}
                            </p>
                        </article>
                    </ng-container>

                    <ng-container *ngIf="env.ONBOARDING.FLOW.TYPE === 'IMAGE'">
                        <img
                            class="h-full w-full object-cover"
                            *ngIf="onlyPortraitMode$ | async"
                            aria-hidden="true"
                            src="{{ assetsPath$ | async }}/img/onboarding/slide-image-{{ +i }}.png"
                            alt="" />

                        <article
                            class="gl-light-dark:w-80 absolute left-0 right-0 top-8 mx-auto w-60"
                            [ngClass]="{ hidden: i !== currentSlide }"
                            aria-live="polite">
                            <h1 class="text-bold text-center text-xl text-black">
                                {{ 'ONBOARDING_SLIDE_TITLE_' + i | translate }}
                            </h1>
                            <p class="mt-4 text-center text-black">
                                {{ 'ONBOARDING_SLIDE_TEXT_' + i | translate }}
                            </p>
                        </article>
                    </ng-container>
                </ng-template>
                <ng-template *ngIf="isShowTermsAndConditions" swiperSlide>
                    <rwidget-terms-and-conditions-selection
                        [ngClass]="{ hidden: env.ONBOARDING.FLOW.SLIDES !== currentSlide }"
                        [termsAgreed]="termsAgreed"
                        (setTermsAgreed)="setTermsAgreed($event)"></rwidget-terms-and-conditions-selection>
                </ng-template>
            </swiper>

            <div
                class="prevButton swiper-button-prev"
                *ngIf="env.ONBOARDING.BACK_BUTTON_LANGUAGE && isFirstSlide"
                [attr.aria-label]="'SWITCH_TO_PREVIOUS' | translate"
                (click)="updateOnBoardingStatus(onboardingType.STARTED)"
                role="button"></div>
        </div>

        <!-- Login Flow -->
        <div class="h-full w-full" *ngSwitchCase="onboardingType.LOGIN_FLOW">
            <rwidget-onboarding-login (themeToggle)="toggleContrast()"></rwidget-onboarding-login>
        </div>
    </ng-container>
</div>
